import { render, staticRenderFns } from "./MainTwitch.vue?vue&type=template&id=4769166f&"
import script from "./MainTwitch.vue?vue&type=script&lang=js&"
export * from "./MainTwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports